// extracted by mini-css-extract-plugin
export default {"wrapper":"vG-z","response":"wG-z","error":"xG-z","disabled":"yG-z","buttons":"zG-z","feedbackQuestionSection":"AG-z","yesNoWrapper":"BG-z"};